import { useParams } from "react-router-dom";
import { LauraAuditView } from "@/app/components/laura/LauraAuditView";

export default function LauraAuditPage() {
    const { id } = useParams<{ id: string }>();
    if (!id) return null;
    return <LauraAuditView auditId={id} />;
}
